export class InvestmentOption {
	code: number;
	description: string;
	paperTp: number;
	lastCotation: number;
	days: number;
	daysTp: string;
	rentability: string;
	finalDate: string;
	percIndex: number;
	yearTax: number;
	taxTp: number;
	yeld: number;
	IOF: number;
	IR: number;
	liquid: number;
	mainValue: number;
	grossValue: number;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/models/investmentOption.ts